import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify";

import SynchronizationsForm from "./SynchronizationsForm";
import * as dataActions from "../../../../../utils/data/dataActions";

import { PROCESS_SYNC } from "../../../../../utils/data/models";
import { processSyncType } from "./synchronizationTypes";
import { SIMPLE_POST_FAILURE } from "../../../../../utils/data/dataActionTypes";
import { FormattedMessage } from "react-intl";
import simpleFetch from "../../../../../../utils/simpleFetch";
import SynchronizationDataTable from "./SynchronizationDataTable";
import { isSimpleFetchToast } from "../../../../common/RouteValidators/ClientValidationHelper";
import { BSModal } from "../../../../common";

class SynchronizationsPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            doRefresh: 0,
            delay: 5000, // 5 seconds
            maxDelay: 600000, // 10 min
            currentIntervalStatus: processSyncType.INIT,
            disableSyncButton: true,
            showWarningModal: false,
            currentBillingPeriodId: null,
            modalStringMember: "",
            modalStringDependent: "",
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.incrementDoRefresh = this.incrementDoRefresh.bind(this);
        this.startSetInterval = this.startSetInterval.bind(this);
        this.increaseIntervalDelay = this.increaseIntervalDelay.bind(this);
        this.clearInterval = this.clearInterval.bind(this);
        this.makeSynchronizationCall = this.makeSynchronizationCall.bind(this);
        this.fetchWarnings = this.fetchWarnings.bind(this);
        // this.renderWarningsModal = this.renderWarningsModal.bind(this);
        this.buildArrayStrings = this.buildArrayStrings.bind(this);

        this.interval = null;
    }

    componentDidMount() {
        const {
            client: { clientId },
        } = this.props;
        const endpoint = PROCESS_SYNC.path.replace("{}", clientId);
        simpleFetch("GET", endpoint, {
            query: { sortBy: "createdAt:desc", limit: 1 },
        }).then((res) => {
            if (res.items && res.items.length > 0) {
                const status = res.items[0].status;
                if (
                    status !== processSyncType.FAILURE &&
                    status !== processSyncType.SUCCESS &&
                    status !== processSyncType.INCOMPLETE
                ) {
                    this.startSetInterval();
                } else {
                    this.setState({ disableSyncButton: false });
                }
            } else {
                this.setState({ disableSyncButton: false });
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.delay !== this.state.delay) {
            this.increaseIntervalDelay();
        }
    }

    componentWillUnmount() {
        this.clearInterval();
    }

    increaseIntervalDelay() {
        /**
         * Since setInterval is saved in memory, we need
         * to clear it and start a new one each time the delay state
         * is increased.
         */
        this.clearInterval();
        this.startSetInterval();
    }

    clearInterval() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    startSetInterval() {
        const {
            client: { clientId },
        } = this.props;
        const endpoint = PROCESS_SYNC.path.replace("{}", clientId);

        this.interval = setInterval(() => {
            simpleFetch("GET", endpoint, {
                query: { sortBy: "createdAt:desc", limit: 1 },
            }).then((res) => {
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        delay: Math.min((prevState.delay *= 2), this.state.maxDelay),
                    };
                });
                if (res.items && res.items.length > 0) {
                    const status = res.items[0].status;
                    if (status !== this.state.currentIntervalStatus) {
                        this.incrementDoRefresh();
                        this.setState({ currentIntervalStatus: status });
                        if (
                            status === processSyncType.SUCCESS ||
                            status === processSyncType.FAILURE ||
                            status === processSyncType.INCOMPLETE
                        ) {
                            this.setState({ disableSyncButton: false, delay: 5000, currentIntervalStatus: null });
                            this.clearInterval();
                        }
                    }
                }
            });
        }, this.state.delay);
    }

    fetchWarnings(clientId, billingPeriodId) {
        if (billingPeriodId === null || billingPeriodId === undefined) {
            return;
        }
        return simpleFetch(
            "GET",
            `/v1/clients/${clientId}/process-sync/${billingPeriodId}/get-synchronization-warnings`,
            {}
        );
    }

    renderFormatedMessage(icon) {
        return <span className="icon warning">{icon}</span>;
    }

    // renderWarningsModal() {
    //     return (
    //         <BSModal
    //             show={this.state.showWarningModal}
    //             actions={[
    //                 {
    //                     id: 1,
    //                     disabled: false,
    //                     text: <FormattedMessage id="common.confirm" />,
    //                     action: this.makeSynchronizationCall,
    //                 },
    //             ]}
    //             onClose={() => this.setState({ showWarningModal: false, disableSyncButton: false })}
    //             title={
    //                 <span>
    //                     <FormattedMessage id="messages.datatable.actions.showConfirm.title">
    //                         {this.renderFormatedMessage}
    //                     </FormattedMessage>
    //                 </span>
    //             }
    //         >
    //             <div className="modal-spacing-break">
    //                 {this.state.modalStringMember && this.state.modalStringMember.length > 0 && (
    //                     <span className="scrollable-modal">
    //                         <b>
    //                             <FormattedMessage id="clients.client.processSync.form.warnings.memberCoverageOverlapWarning" />
    //                         </b>
    //                         <br />
    //                         <br />
    //                         {this.state.modalStringMember}
    //                     </span>
    //                 )}

    //                 {this.state.modalStringDependent && this.state.modalStringDependent.length > 0 && (
    //                     <span className="scrollable-modal">
    //                         <b>
    //                             <FormattedMessage id="clients.client.processSync.form.warnings.dependentPersonCoverageOverlapWarning" />
    //                         </b>
    //                         <br />
    //                         <br />
    //                         {this.state.modalStringDependent}
    //                     </span>
    //                 )}
    //             </div>
    //         </BSModal>
    //     );
    // }

    onSubmit(values) {
        const {
            client: { clientId },
        } = this.props;
        this.setState({ disableSyncButton: true });
        this.makeSynchronizationCall();
        
        // toast(<FormattedMessage id="clients.client.processSync.form.fetchingWarningsMessage" />, {
        //     type: toast.TYPE.INFO,
        //     autoClose: false,
        // });


        // this.fetchWarnings(clientId, values.billingPeriodId).then((res) => {
        //     let stringBuilderArray = [];
        //     let modalStringMember = "";
        //     let modalStringDependent = "";

        //     if (res) {
        //         const keys = ["dependentPersonCoverageOverlapWarning", "memberCoverageOverlapWarning"];

        //         keys.forEach((k) => {
        //             this.buildArrayStrings(res, k, stringBuilderArray);
        //         });

        //         if (Array.isArray(stringBuilderArray) && stringBuilderArray.length > 0) {
        //             const memberElements = stringBuilderArray.filter((e) => e.type == "memberCoverageOverlapWarning");
        //             const dependentElements = stringBuilderArray.filter(
        //                 (e) => e.type == "dependentPersonCoverageOverlapWarning"
        //             );

        //             memberElements.forEach((m) => {
        //                 modalStringMember += `${m.firstName} ${m.lastName} - ${m.coverageStartDate}\n\n`;
        //             });

        //             dependentElements.forEach((d) => {
        //                 modalStringDependent += `${d.firstName} ${d.lastName} - ${d.coverageStartDate}\n\n`;
        //             });

        //             this.setState({ modalStringDependent, modalStringMember }, () => {
        //                 this.setState({ showWarningModal: true });
        //             });
        //         } else {
        //             this.makeSynchronizationCall();
        //         }
        //     } else {
        //         this.makeSynchronizationCall();
        //     }

        //     toast.dismiss();
        // });
    }

    buildArrayStrings(obj, elementKey, stringBuilderArray) {
        const nestedObj = obj[elementKey];

        for (const key in nestedObj) {
            const element = nestedObj[key];
            const coverage = element["coverage"];
            const person = element["person"];

            stringBuilderArray.push({
                firstName: person["firstName"],
                lastName: person["lastName"],
                coverageStartDate: coverage["startDate"],
                type: elementKey,
            });
        }
    }

    makeSynchronizationCall() {
        const {
            client: { clientId },
            dataActions,
            billingPeriodId,
        } = this.props;
        // this.setState({ showWarningModal: false });
        if (!billingPeriodId) {
            return;
        }

        const body = { billingPeriodId: billingPeriodId };
        const endpoint = PROCESS_SYNC.path.replace("{}", clientId);
        const model = { ...PROCESS_SYNC, path: endpoint };
        return dataActions.simplePost({ model, data: body }).then((data) => {
            toast.dismiss("processSent");
            if (!isSimpleFetchToast(data)) {
                if (data.type == SIMPLE_POST_FAILURE) {
                    if (data.payload.error.data.error === "process_sync_limit_error") {
                        toast(<FormattedMessage id="clients.client.processSync.errors.processSyncLimitError" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                        this.incrementDoRefresh();
                        this.startSetInterval();
                    } else {
                        toast(<FormattedMessage id="clients.client.processSync.form.syncSentFailure" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                    }
                } else {
                    toast(<FormattedMessage id="clients.client.processSync.form.syncSentSuccess" />, {
                        type: toast.TYPE.SUCCESS,
                        autoClose: 5000,
                    });
                    this.incrementDoRefresh();
                    this.startSetInterval();
                }
            }
        });
    }

    incrementDoRefresh() {
        this.setState((prevState) => {
            return {
                ...prevState,
                doRefresh: prevState.doRefresh + 1,
            };
        });
    }

    render() {
        const {
            client: { clientId, clientStatusType },
        } = this.props;

        return (
            <div className="sub-content">
                <SynchronizationsForm
                    disableSyncButton={this.state.disableSyncButton}
                    clientId={clientId}
                    clientStatusType={clientStatusType}
                    onSubmit={this.onSubmit}
                />
                <SynchronizationDataTable doRefresh={this.state.doRefresh} />
                {/* {this.state.showWarningModal && this.renderWarningsModal()} */}
            </div>
        );
    }
}

SynchronizationsPage.propTypes = {
    client: PropTypes.object,
    dataActions: PropTypes.object,
    billingPeriodId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
};

function mapStateToProps(state) {
    const clients = state.data.clients || {};

    return {
        client: clients.active || {},
        billingPeriodId:
            state.form &&
            state.form["synchronisationsForm"] &&
            state.form["synchronisationsForm"].values &&
            state.form["synchronisationsForm"].values.billingPeriodId,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SynchronizationsPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/synchronizations/SynchronizationsPage.js